import { render, staticRenderFns } from "./AtomImage.vue?vue&type=template&id=0410de0d&"
import script from "./AtomImage.vue?vue&type=script&lang=js&"
export * from "./AtomImage.vue?vue&type=script&lang=js&"
import style0 from "./AtomImage.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AtomImage.vue"
export default component.exports